import Day from 'components/Day';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';
import React from 'react';
import formatDate from 'utils/formatDate';

const CSS = require('./Week.module.scss');

const today = startOfDay(new Date());

interface WeekProps {
  parentKey: string;
  days: number[];
  month: Date;
  onSelect: (e: Date) => void;
  startDate: Date;
  endDate: Date;
  availableDays?: Map<string, boolean>;
  markedDays?: Map<string, boolean>;
}

const Week = ({
  parentKey,
  days,
  month,
  onSelect,
  startDate,
  endDate,
  availableDays,
  markedDays,
}: WeekProps) => {
  return (
    <div className={CSS.Week}>
      {days.map((day, dayIndex) => {
        const date = new Date(month.getFullYear(), month.getMonth(), day);
        const dateString = formatDate(date, 'yyyy-MM-dd');
        const dateInPast = isBefore(date, today);

        return (
          <Day
            startDate={startDate}
            endDate={endDate}
            key={`${parentKey}-${dayIndex}`}
            day={day}
            date={date}
            disabled={
              dateInPast || (!!availableDays && !availableDays.get(dateString))
            }
            marked={!dateInPast && !!markedDays && markedDays.get(dateString)}
            onSelect={onSelect}
          />
        );
      })}
    </div>
  );
};

export default Week;
